import {
  FETCHED_PAIRS,
  FETCHED_MATCHED_PAIRS,
  FETCHED_MATCHED_ORDERS,
  FETCHED_MY_MATCHED_ORDERS,
  FETCHED_PAST_ORDERS,
  FETCHED_MY_PAST_ORDERS,
} from '../../types';

import callBC from '../../helpers/bc'
import {getBlake} from '../../passport/get';
import {fromUnit} from '../../../config';
import {deletePending,triggerEvents} from '../../ui/marketplace';
import {lowestDenom} from '../../../config';

export async function getMatchedOrders(history,dispatch,state){
  try {
    let data = await callBC(state.settings.settings,'getMatchedOrders',[history])
    let newPairs = JSON.parse(JSON.stringify(require('../../../config').pairs))

    let {newOrders,pairs} = data.result && data.result.ordersList ?
      cleanUpMatchedOrders(newPairs,data.result.ordersList,state.socket.bcHeight,state.socket.timestamp) : [];

    let blake_address = state.passport.blake ? state.passport.blake : await getBlake(dispatch,state);
    let my_matched = []
    newOrders.forEach(o => {
      if(o.maker.doubleHashedBcAddress === blake_address) {
        my_matched.push({...o,isMaker:true})
      }
      if(o.taker.doubleHashedBcAddress === blake_address) {
        my_matched.push({...o,isTaker:true})
      }
    });

    my_matched = cleanUpMyMatchedOrders(my_matched,state.pending.transactions)

    dispatch({
      type:FETCHED_MY_MATCHED_ORDERS,
      payload:my_matched.filter(o=>o.past == false)
    });

    dispatch({
      type:FETCHED_MY_PAST_ORDERS,
      payload:my_matched.filter(o=>o.past)
    });

    dispatch({
      type:FETCHED_MATCHED_ORDERS,
      payload:newOrders
    })

    dispatch({
      type:FETCHED_MATCHED_PAIRS,
      payload:pairs
    })

    triggerEvents(my_matched,state,dispatch)

    deletePending(my_matched,state,dispatch)
  }
  catch(err){
    console.log({err})
  }
}

//HELPER FUNCTIONS
let cleanUpMatchedOrders = (pairs,orders,bcHeight,timestamp) => {
  let newOrders = orders.map(o => {
    o.taker.collateralizedNrg = o.taker.totalCollateral;
    o.deadline =`in ${o.maker.tradeHeight + o.maker.settlement - bcHeight} Blocks`;
    o.past = o.maker.tradeHeight + o.maker.settlement <= bcHeight;
    o.maker.receivesUnit = fromUnit(o.maker.receivesToChain,o.maker.receivesUnit)
    o.maker.sendsUnit = fromUnit(o.maker.sendsFromChain,o.maker.sendsUnit)
    o.txHash = o.taker.txHash
    o.txOutputIndex = o.taker.txOutputIndex;

    let divider = o.maker.collateralizedNrg / (o.taker.collateralizedNrg / o.maker.base);

    let demand = pairs['bid/ask'].concat(pairs['auction']).reduce((total,{denomination,asset})=>{
      return total || (asset.toLowerCase() == o.maker.sendsFromChain.toLowerCase() && denomination.toLowerCase() == o.maker.receivesToChain.toLowerCase())
    },false)

    if(demand){
      o.price = o.maker.receivesUnit / o.maker.sendsUnit / divider;
      o.amount = o.maker.sendsUnit / divider;
      o.color = `rgb(101, 173, 97)`;
    } else {
      o.price = o.maker.sendsUnit / o.maker.receivesUnit / divider;
      o.amount = o.maker.receivesUnit / divider;
      o.color = `rgb(222, 114, 114)`;
    }

    o.timestamp = (timestamp*1000) - ((bcHeight - o.taker.tradeHeight)*5000)

    if(o.maker.sendsFromChain.toLowerCase() == 'nrg'){
      pairs['auction'].map(({asset,denomination},index)=>{
        if(asset.toLowerCase() == o.maker.receivesToChain.toLowerCase()){
          if(new Date(pairs['auction'][index].lastPrice.time) < new Date(o.timestamp)){
            pairs['auction'][index].lastPrice = {time: new Date(o.timestamp),price:o.price}
          }
          pairs['auction'][index].volume += o.price*o.amount
          pairs['auction'][index].pastOrders.push(o)
        }
      })
    }
    else {
      pairs['bid/ask'].map(({asset,denomination},index)=>{
        if(asset.toLowerCase() == o.maker.sendsFromChain.toLowerCase() && denomination.toLowerCase() == o.maker.receivesToChain.toLowerCase()){

          if(new Date(pairs['bid/ask'][index].lastPrice.time) < new Date(o.timestamp)){
            pairs['bid/ask'][index].lastPrice = {time: new Date(o.timestamp),price:o.price}
          }
          pairs['bid/ask'][index].volume += o.price*o.amount
          pairs['bid/ask'][index].pastOrders.push(o)
        }
        else if(denomination.toLowerCase() == o.maker.sendsFromChain.toLowerCase() && asset.toLowerCase() == o.maker.receivesToChain.toLowerCase()){

          if(new Date(pairs['bid/ask'][index].lastPrice.time) < new Date(o.timestamp)){
            pairs['bid/ask'][index].lastPrice = {time: new Date(o.timestamp),price:o.price}
          }
          pairs['bid/ask'][index].volume += o.price*o.amount
          pairs['bid/ask'][index].pastOrders.push(o)
        }
      })
    }
    return o;
  })
  return {newOrders,pairs}
}


let cleanUpMyMatchedOrders = (orders,pending) => {
  let {pairs} = require('../../../config');
  let newPairs = JSON.parse(JSON.stringify(pairs))

  return orders.map(o => {
    let divider = o.maker.collateralizedNrg / (o.taker.collateralizedNrg / o.maker.base);

    o.sendsAmount = o.isMaker ? o.maker.sendsUnit / divider : o.maker.receivesUnit / divider;
    o.receivesAmount = o.isMaker ? o.maker.receivesUnit / divider : o.maker.sendsUnit / divider;
    o.sendsFromAddress = o.isMaker ? o.maker.sendsFromAddress : o.taker.sendsFromAddress;
    o.receivesToAddress = o.isMaker ? o.maker.receivesToAddress : o.taker.receivesToAddress;
    o.sendsToAddress = o.isMaker ? o.taker.receivesToAddress : o.maker.receivesToAddress;
    o.receivesFromAddress = o.isMaker ? o.taker.sendsFromAddress : o.maker.sendsFromAddress;
    o.sendsFromChain = o.isMaker ? o.maker.sendsFromChain.toUpperCase() : o.maker.receivesToChain.toUpperCase();
    o.receivesToChain = o.isMaker ? o.maker.receivesToChain.toUpperCase() : o.maker.sendsFromChain.toUpperCase();
    o.collateral = o.taker.collateralizedNrg / o.maker.base + " NRG";
    o.yourStatus = o.isMaker ? o.maker.isSettled : o.taker.isSettled;
    o.theirStatus =  o.isMaker ? o.taker.isSettled : o.maker.isSettled;

    if(pending && Object.keys(pending).length > 0){
      Object.keys(pending).forEach(key => {
        const {amount,chain,from,to} = pending[key];
        if(amount == o.sendsAmount && chain.toUpperCase() == o.sendsFromChain.toUpperCase() && from == o.sendsFromAddress && to == o.sendsToAddress){
          if(!o.yourStatus) o.yourStatus = 'Sending';
        }
      });
    }
    return o;
  })
}
